export enum AggregationType {
  NumberSum = 'number-sum',
  NumberAverage = 'number-average',
  NumberMedian = 'number-median',
  NumberMin = 'number-min',
  NumberMax = 'number-max',
  NumberRange = 'number-range',
  Count = 'count',
  CountDistinct = 'count-distinct',
  CountNonEmpty = 'count-non-empty',
  TimeTrackerSum = 'time-tracker-sum',
  PercentChecked = 'percent-checked',
  PercentUnchecked = 'percent-unchecked',
  CountEmpty = 'count-empty',
  PercentNonEmpty = 'percent-non-empty',
  PercentEmpty = 'percent-empty',
  DateEarliest = 'date-earliest',
  DateLatest = 'date-latest',
  CountChecked = 'count-checked',
  CountUnchecked = 'count-unchecked',
  FirstDateEarliest = 'first-date-earliest',
  SecondDateEarliest = 'second-date-earliest',
  FirstDateLatest = 'first-date-latest',
  SecondDateLatest = 'second-date-latest',
  StatusUnique = 'status-unique',
  LabelUnique = 'label-unique',
  ItemOrderValuesStatus = 'item-order-values-status',
  ItemOrderValuesLabel = 'item-order-values-label',
  RatingSum = 'rating-sum',
  VoteSum = 'vote-sum',
  // TODO: Add number of duplicates
}
